module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "main-wrapper",
    class: {
      'is-blurred': _vm.leftMenuVisible
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.veil_visible),
      expression: "veil_visible"
    }],
    staticClass: "veil"
  }), _vm._v(" "), (_vm.$route.path !== '/login') ? _c('app-header') : _vm._e(), _vm._v(" "), _c('app-left-menu'), _vm._v(" "), _c('app-mob-menu'), _vm._v(" "), _c('main', {
    class: {
      'login': _vm.$route.path === '/login'
    }
  }, [(_vm.$route.path != '/login') ? _c('app-top') : _vm._e(), _vm._v(" "), (_vm.user || _vm.$route.path === '/login') ? _c('router-view') : _vm._e()], 1), _vm._v(" "), _c('app-share-tickets'), _vm._v(" "), _c('app-view-qr'), _vm._v(" "), _c('app-view-qr-card'), _vm._v(" "), _c('app-support'), _vm._v(" "), _c('app-change-name'), _vm._v(" "), _c('next-lvl-requirements'), _vm._v(" "), _c('next-lvl-achieved'), _vm._v(" "), _c('fill-profile'), _vm._v(" "), _c('badge-dets'), _vm._v(" "), _c('points-received'), _vm._v(" "), (_vm.isShowMXPreloader) ? _c('mx-preloader') : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-418622cc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 409
// module chunks = 1